import { render } from "./AgentMonthlyGoalModal.vue?vue&type=template&id=9c6fc838&scoped=true"
import script from "./AgentMonthlyGoalModal.vue?vue&type=script&lang=js"
export * from "./AgentMonthlyGoalModal.vue?vue&type=script&lang=js"

import "./AgentMonthlyGoalModal.vue?vue&type=style&index=0&id=9c6fc838&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c6fc838"]])

export default __exports__